import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Loader } from '@googlemaps/js-api-loader';

import { selectLocale } from 'services/Language/selectors';

import { GOOGLE_MAPS_API_KEY } from '../../env';

const GoogleMapsLoader = () => {
  const locale = useSelector(selectLocale());

  useEffect(() => {
    const loader = new Loader({
      apiKey: GOOGLE_MAPS_API_KEY,
      language: locale,
      // @ts-expect-error TS(2322): Type '"geometry,places"' is not assignable to type... Remove this comment to see the full error message
      libraries: ['geometry,places'],
    });

    loader.load();
  }, []);

  return null;
};

export default GoogleMapsLoader;
